import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "../features/account/style.module.scss";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef?: React.RefObject<HTMLInputElement>;
}
export function PasswordInputUnderline({ inputRef, ...rest }: Props) {
  const { t } = useTranslation(["common"]);
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  return (
    <div className={style.passwordInputWrapper}>
      <input
        type={"password"}
        {...rest}
        ref={inputRef}
        onKeyUp={(e) => {
          if (e.getModifierState("CapsLock")) {
            setIsCapsLockOn(true);
          } else {
            setIsCapsLockOn(false);
          }
        }}
      />
      {isCapsLockOn && <div className={style.errorMessage}>{t("capsLockOn")}</div>}
    </div>
  );
}
